/**
 * Extract UTC date partition folders from an ISO datetime string.
 *
 * @example utcDatePartition("2024-01-15T10:30:00.000Z") // "2024/01/15"
 */
export function utcDatePartition(isoDatetime: string): string {
  const year = isoDatetime.slice(0, 4);
  const month = isoDatetime.slice(5, 7);
  const day = isoDatetime.slice(8, 10);
  return `${year}/${month}/${day}`;
}

/** Regex matching an optional date partition prefix: `YYYY/MM/DD/` */
export const DATE_PARTITION_RE = /^\d{4}\/\d{2}\/\d{2}\//;
